import {
  ImageScaleView,
  ImageSliceView,
  View,
  ViewOpts,
} from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { parseAmount } from 'src/replicant/utils/beautifyNumber';

export class RewardDisplay extends View {
  public readonly icon: ImageScaleView;
  private rewardLabel: LangBitmapFontTextView;

  constructor(opts: ViewOpts) {
    super({
      width: 300,
      height: 88 + 45,
      ...opts,
    });

    const bg = new ImageSliceView({
      superview: this,
      image: 'assets/ui/shared/frames/inset_panel.png',
      slices: {
        left: 25,
        right: 25,
        top: 25,
        bot: 25,
      },
      centerOnOrigin: true,
      height: 88,
      width: 300,
      ...opts,
    });

    this.icon = new ImageScaleView({
      superview: bg,
      scaleMethod: 'contain',
      image: 'assets/ui/hud/icons/hud_coin.png',
      width: 74,
      height: 74,
      x: 10,
      y: 7,
    });

    this.rewardLabel = new LangBitmapFontTextView({
      superview: bg,
      size: 38,
      font: 'Body',
      height: 68,
      width: 196,
      verticalAlign: 'center',
      align: 'center',
      x: 90,
      y: 8,
    });
  }

  public setReward(reward: number) {
    this.rewardLabel.localeText = () => `X ${parseAmount(reward)}`;
  }

  public setIcon(icon: 'coin' | 'energy') {
    this.icon.updateOpts({
      image: `assets/ui/hud/icons/hud_${icon}.png`,
    });
  }
}
